module.exports = __webpack_public_path__ + "static/media/298174.cdbcc098.png";